import {
  GET_WALLET_SUMMARY_SUCCESS,
  GET_WALLET_SUMMARY_FAILURE,
  GET_WALLET_TRANSACTIONS_SUCCESS,
  GET_WALLET_TRANSACTIONS_FAILURE
} from '../actionTypes';

const initialState = {
  walletData: {},
  walletTransactionData: {}
};

export default function WalletReducer(state = initialState, action) {
  switch (action.type) {
    case GET_WALLET_SUMMARY_SUCCESS: {
      const { value = {} } = action;
      return { ...state, walletData: value };
    }

    case GET_WALLET_SUMMARY_FAILURE: {
      return { ...state };
    }

    case GET_WALLET_TRANSACTIONS_SUCCESS: {
      const { value = {} } = action;
      return { ...state, walletTransactionData: value };
    }

    case GET_WALLET_TRANSACTIONS_FAILURE: {
      return { ...state };
    }

    default: {
      return {
        ...state
      };
    }
  }
}
